var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ul',{staticClass:"plain-unordered-list"},_vm._l((_vm.items),function(item,index){return _c('li',{key:index},[_vm._v(_vm._s(item))])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }